<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Calendario de seguimientos</h2></v-toolbar-title></pre>
                    </v-toolbar>

                    <v-form class="mt-3"> </v-form>
                </v-col>
            </v-row>
            <v-row justify="end">
                <v-tooltip right style="margin-bottom: 5px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            to="lista-seguimiento"
                            :loading="isloading"
                            :disabled="isloading"
                            color="blue"
                            class="mt-4 mx-3"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text"
                                >mdi-arrow-left-bold-outline</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Volver</span>
                </v-tooltip>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <FilterComponentVue
                        :headers="filter_headers"
                        v-model="filtros_prueba"
                    ></FilterComponentVue>
                </v-col>
                <v-col cols="12" md="3">
                    <date-select v-model="fecha" label="Fecha"></date-select>
                </v-col>
                <v-col cols="12" md="3">
                    <v-autocomplete
                        @update:search-input="SearchCliente"
                        v-model="seguimiento.id_cliente"
                        :items="clientes"
                        item-text="nombre_comercial"
                        item-value="id"
                        label="Cliente"
                    >
                        <template v-slot:append-item>
                            <div v-intersect="endIntersect" />
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <citapickerhoras
                        :fecha="fecha"
                        @getSeguimientos="getSeguimientos"
                        v-model="Seguimientos"
                    ></citapickerhoras>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import { debounce } from "../../../helpers";
import citapickerhoras from "./citapickerhoras.vue";
export default {
    data() {
        return {
            fecha: null,
            filters: null,
            filtros_prueba: {
                search: "",
            },
            filter_headers: [
                {
                    title: "Agente",
                    type: "select",
                    active: false,
                    model: "agente",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Estado",
                    type: "select",
                    active: false,
                    model: "estado",
                    item_text: "nombre",
                    item_value: "id",
                },
            ],
            rol: 0,
            //clientes: [],
            seguimiento: {},
            agentes: {},
            Seguimientos: [],
            controles: [],
            acciones: [],
            productos: [],
        };
    },

    created() {
        //this.getSeguimientos();
        // this.getClientes();
        this.getSeguimientos();
        this.getAgentes();
        this.getEstadosPotencial();
        if (this.$store.getters.getfiltros["seguimientos"] != null) {
            this.filtros_prueba =
                this.$store.getters.getfiltros["seguimientos"];
        }
    },
    methods: {
        getEstadosPotencial() {
            axios.get(`api/get-estados-potencial`).then((res) => {
                this.filter_headers[1].items = res.data;
            });
        },
        getAgentes() {
            axios.get(`api/get-agentes`).then((res) => {
                this.filter_headers[0].items = [
                    ...[{ id: 0, nombre: "Sin Asignar" }],
                    ...res.data.Agentes,
                ];
                this.agentes = res.data.Agentes;
            });
        },
        Filtrar() {
            axios
                .get(
                    `api/get-seguimiento-cliente/${this.seguimiento.id_cliente}`
                )
                .then(
                    (res) => {
                        this.Seguimientos = res.data.seguimientos;
                    },
                    (err) => {
                        this.$custom_error("Error consultando el seguimiento");
                    }
                );
        },
        getProductos() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.productos = res.data.Productos;
                },
                (res) => {}
            );
        },
        getControles() {
            axios.get(`api/get-seguimiento-controles`).then(
                (res) => {
                    let data = res.data;
                    this.controles = data.controles;
                },
                (res) => {}
            );
        },
        getAcciones() {
            axios.get(`api/get-seguimiento-acciones`).then(
                (res) => {
                    let data = res.data;
                    this.acciones = data.acciones;
                },
                (res) => {}
            );
        },
        SearchCliente: debounce(function (val) {
            if (val) {
                this.$store.dispatch("searchCliente", {
                    search: val,
                    rol: this.rol,
                });
            }
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getClientesNext", this);
            }
        },
        getClientes() {
            axios.get(`api/get-clientes/-1`).then(
                (res) => {
                    this.clientes = res.data.data;
                },
                (res) => {}
            );
        },
        getSeguimientos(filter) {
            if (filter != null) {
                this.filters = filter;
            }
            if (this.filters == null) return;
            /*let filtros = this.filterString;

            if (this.seguimiento.id_cliente != null) {
                filtros += `&cliente=${this.seguimiento.id_cliente}`;
            }
            if (
                this.filtros_prueba.search != null &&
                this.filtros_prueba.search != ""
            ) {
                filtros += `&search=${this.filtros_prueba.search}`;
            }

            if (this.filtros_prueba.agente)
                filtros +=
                    this.filtros_prueba.agente.value != null
                        ? `&id_agente=${this.filtros_prueba.agente.value}`
                        : ""; */

            // axios.get(`api/get-seguimientos${this.filters}${filtros}`).then(
            axios
                .get(`api/get-seguimientos`, {
                    params: {
                        cliente: this.seguimiento.id_cliente,
                        search: this.filtros_prueba?.search,
                        id_agente: this.filtros_prueba?.agente?.value,
                        id_estado: this.filtros_prueba?.estado?.value,
                        fecha_inicio: this.filters?.fecha_inicio,
                        fecha_fin: this.filters?.fecha_fin,
                    },
                })
                .then(
                    (res) => {
                        this.Seguimientos = res.data.seguimientos;
                        //console.log(this.Seguimientos);
                    },
                    (err) => {
                        this.$custom_error(
                            "Error consultando los seguimientos"
                        );
                    }
                );
        },
        formatNumber(number) {
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
    },
    filters: {},
    components: {
        citapickerhoras,
        FilterComponentVue,
    },

    watch: {
        filtros_prueba: {
            deep: true,
            handler: debounce(function (val) {
                this.$store.dispatch("saveFiltrosSeguimiento", val);
                this.getSeguimientos();
            }, 500),
        },
        "seguimiento.id_cliente": {
            deep: true,
            handler: debounce(function (val) {
                this.getSeguimientos();
            }, 500),
        },
        fecha: {
            handler: debounce(function (val) {
                this.getSeguimientos({ fecha_inicio: val });
            }, 200),
        },
    },
    computed: {
        clientes() {
            /////console.log("siva");
            let clientes_temp = this.$store.getters.getclientes;

            return clientes_temp;
        },
        filterString() {
            let filtros = "";
            if (
                this.filtros_prueba.search != null &&
                this.filtros_prueba.search != ""
            ) {
                filtros += `&busqueda=${this.filtros_prueba.search}`;
            }
            this.filter_headers.forEach((head) => {
                if (this.filtros_prueba[head.model]) {
                    if (head.type == "date") {
                        if (
                            this.filtros_prueba[head.model].start != "" &&
                            this.filtros_prueba[head.model].start != null
                        ) {
                            filtros += `&${head.model}_desde=${
                                this.filtros_prueba[head.model].start
                            }`;
                        }
                        if (
                            this.filtros_prueba[head.model].end != "" &&
                            this.filtros_prueba[head.model].end != null
                        ) {
                            filtros += `&${head.model}_hasta=${
                                this.filtros_prueba[head.model].end
                            }`;
                        }
                    } else {
                        if (
                            (this.filtros_prueba[head.model].value != "" &&
                                this.filtros_prueba[head.model].value !=
                                    null) ||
                            (this.filtros_prueba[head.model].nombre != "" &&
                                this.filtros_prueba[head.model].nombre != null)
                        ) {
                            filtros += `&${head.model}=${
                                this.filtros_prueba[head.model].value
                            }`;
                        }
                    }
                }
            });
            return filtros;
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}
.spacing {
    padding-top: 0 !important;
}
</style>
